import { CSSProperties } from 'fela';
import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  iframe: CSSProperties;
}

const styles = (): IStyles => ({
  wrapper: {
    paddingBottom: '56.25%' /* 16:9 */,
    paddingTop: '25px',
    height: 0,
  },

  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    border: 'none',
  },
});

export default styles;
